import {
  computeImpact,
  displayImpact,
} from '@captaincause/lib/impact/computeImpact'
import { Container } from './Container'
import i18n from './i18n'
import type { Amount, Locales, Project } from '@captaincause/types'

interface ProjectImpactContributionProps {
  className?: string
  contributedAmount?: Amount
  locale: Locales
  pointsMode?: boolean
  pointsValueInCents?: number | null
  project: Project
}

export function ProjectImpactContribution({
  className = '',
  contributedAmount = undefined,
  locale,
  pointsMode = false,
  pointsValueInCents = null,
  project,
}: ProjectImpactContributionProps) {
  const t = i18n[locale]

  if (!contributedAmount || contributedAmount.amount === 0 || !project.action) {
    return (
      <Container
        project={project}
        locale={locale}
        className={className}
        hideImpactBox
      />
    )
  }

  const contributionImpact = computeImpact({
    amount: contributedAmount,
    action: project.action,
  })
  const displayedContributionImpact =
    contributionImpact && contributionImpact > 1 ? contributionImpact : 1

  if (!contributionImpact) {
    return (
      <Container
        project={project}
        locale={locale}
        className={className}
        hideImpactBox
      />
    )
  }

  const contributionFundImpact = contributionImpact >= 1

  return (
    <Container
      project={project}
      locale={locale}
      className={className}
      pointsMode={pointsMode}
      pointsValueInCents={pointsValueInCents}
      showImpactConversion
    >
      <div className="text-xs text-dark-beige">
        {contributionFundImpact ? t.youFund : t.youContribute}
      </div>
      <div
        className="line-clamp-2 text-lg font-semibold text-black"
        style={{ wordBreak: 'break-word' }}
      >
        {displayImpact({
          action: project.action,
          value: { numItems: displayedContributionImpact },
          locale,
          length: 'long',
        })}{' '}
        👏
      </div>
    </Container>
  )
}
